{
  "more": "Περισσότερα στοιχεία"
}
